/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ccsl_Export_Header_Timecode_OutInputs */

const en_ccsl_export_header_timecode_out = /** @type {(inputs: Ccsl_Export_Header_Timecode_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode Out`)
};

const fr_ccsl_export_header_timecode_out = /** @type {(inputs: Ccsl_Export_Header_Timecode_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode sortie`)
};

const de_ccsl_export_header_timecode_out = /** @type {(inputs: Ccsl_Export_Header_Timecode_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode Out`)
};

const it_ccsl_export_header_timecode_out = /** @type {(inputs: Ccsl_Export_Header_Timecode_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uscita timecode`)
};

const ru_ccsl_export_header_timecode_out = /** @type {(inputs: Ccsl_Export_Header_Timecode_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Таймкод отсутствует`)
};

const es_ccsl_export_header_timecode_out = /** @type {(inputs: Ccsl_Export_Header_Timecode_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salida de código de tiempo`)
};

const zh_cn2_ccsl_export_header_timecode_out = /** @type {(inputs: Ccsl_Export_Header_Timecode_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间码输出`)
};

const ja_ccsl_export_header_timecode_out = /** @type {(inputs: Ccsl_Export_Header_Timecode_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコード出力`)
};

const hi_ccsl_export_header_timecode_out = /** @type {(inputs: Ccsl_Export_Header_Timecode_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड आउट`)
};

const pt_pt2_ccsl_export_header_timecode_out = /** @type {(inputs: Ccsl_Export_Header_Timecode_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saída de código de tempo`)
};

/**
* | output |
* | --- |
* | "Timecode Out" |
*
* @param {Ccsl_Export_Header_Timecode_OutInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ccsl_export_header_timecode_out = /** @type {((inputs?: Ccsl_Export_Header_Timecode_OutInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ccsl_Export_Header_Timecode_OutInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ccsl_export_header_timecode_out(inputs)
	if (locale === "de") return de_ccsl_export_header_timecode_out(inputs)
	if (locale === "it") return it_ccsl_export_header_timecode_out(inputs)
	if (locale === "ru") return ru_ccsl_export_header_timecode_out(inputs)
	if (locale === "es") return es_ccsl_export_header_timecode_out(inputs)
	if (locale === "zh-CN") return zh_cn2_ccsl_export_header_timecode_out(inputs)
	if (locale === "ja") return ja_ccsl_export_header_timecode_out(inputs)
	if (locale === "hi") return hi_ccsl_export_header_timecode_out(inputs)
	if (locale === "pt-PT") return pt_pt2_ccsl_export_header_timecode_out(inputs)
	return en_ccsl_export_header_timecode_out(inputs)
});